import { browserName, fullBrowserVersion, osName, osVersion } from 'react-device-detect';

const DetectRTC = require('detectrtc');

window.constraints = {
    audio: {
        echoCancellation: true
    },
}

export const onUnload = e => { // the method that will be used for both add and remove event
    e.preventDefault();
    e.returnValue = '';
}

/**
 * @param {('all'|'os'|'browser')} type - determines which specific data about system is to be returned
 * @returns System/Browser details
 */
export const deviceDetails = (type = 'all') => {
    if(type === 'all') {
        return {
            'osversion' : osVersion,
            'osname' : osName,
            'fullversion' : fullBrowserVersion,
            'browsername' : browserName,
        }
    } else if (type === 'os'){
        return osName;
    } else if(type === 'browser') {
        return browserName;
    }
}

export const locationInfo = () => {
    return {
        "city": "",
        "country": "",
        "lat": 0,
        "long": 0,
        "state": "",
        "zipcode": ""
    }
}

export const initializeLocalMedia = (successCallback) =>  {
    return new Promise((resolve, reject) => {
        let navigator = window.navigator;
        let isGetUserMediaSupported = false;
        if (navigator.getUserMedia || ( navigator.mediaDevices?.getUserMedia )) {
           isGetUserMediaSupported = true;
        } 
        if (isGetUserMediaSupported) {
           let isBlackBerry = !!(/BB10|BlackBerry/i.test(navigator.userAgent || ''));
           if (isBlackBerry || typeof navigator.mediaDevices === 'undefined' || typeof navigator.mediaDevices.getUserMedia !== 'function') {
               navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
               navigator.getUserMedia(window.constraints).then(function (stream) {
                   console.log(stream);
                   return resolve(stream);
               }, function (error) {
                   console.log(error);
                   return reject(error);
               });
           }
        }
        if (navigator.mediaDevices.getUserMedia === 'undefined') {
           navigator.mediaDevices.getUserMedia = function () {
               // First get ahold of the legacy getUserMedia, if present
               let getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
               // Some browsers just don't implement it - return a rejected promise with an error
               // to keep a consistent interface
               if (!getUserMedia) {
                   reject(new Error('getUserMedia is not implemented in this browser'));
               }
           };
        }
        navigator.mediaDevices.getUserMedia(window.constraints).then(
        function (stream) {
            successCallback(stream);
            return resolve(stream);
        }).catch(function (err) {
                    console.log(err);
            return reject(err);
        });
    });
};

export const detectSystem = (callback, loaderCallback, errorCallback, initializeCallback) => {
    
    if ( DetectRTC.isWebRTCSupported) {
        if(typeof loaderCallback != 'undefined')
            loaderCallback();
            
        DetectRTC.load(function () {
            initializeLocalMedia((stream) => {
                console.log('Successfully captured local stream');
                initializeCallback(stream)
            }).then(stream => {
                callback(stream, DetectRTC.hasWebcam, DetectRTC.hasMicrophone);
            }).catch(function (err) {
                console.log(err);
                errorCallback(err);                
            });
        });
    } 
}
export const consoleHelper =(...data )=>{
    if(process.env.REACT_APP_ENV !=="production") {
        console.log(...data);}}


export const getYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear;
  };



// Helper function to convert sql data into data table
export const convertSqlOutput = (outputStr, outputColor = '') => {
    if (!outputStr) return null;

    const rows = outputStr.split("\n").filter(row => row.trim() !== '');

    return (
      <div className="table-responsive">
        <table className={`table table-bordered coding-output-dotted-table ${outputColor}`}>
          <tbody>
            {rows.map((row, rowIndex) => {
              const columns = row.split("|");
              return (
                <tr key={`rows -${rowIndex}`}>
                  {columns.map((col, colIndex) => (
                    <td key={colIndex}>{col.trim()}</td> // Trim any extra spaces
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
};